import * as React from 'react';
import styled from 'styled-components';

import EventsMetrics from 'components/events/EventsMetrics';
import EventsCategoriesHistogram from 'security-app/components/SecurityEvents/Alerts/MitreCategories/EventsCategoriesHistogram';
import type { MiddleSectionProps } from 'components/common/PaginatedEntityTable/PaginatedEntityTable';
import ExportResultsButton from 'security-app/components/SecurityEvents/Alerts/ExportResultsButton';
import MetricsAction from 'security-app/components/SecurityEvents/Alerts/MetricsAction';
import SecurityEventsHistogram from 'security-app/components/SecurityEvents/Alerts/SecurityEventsHistogram';
import IfPermitted from 'components/common/IfPermitted';
import permissions from 'security-app/Permissions';

const WidgetsContainer = styled.div`
  display: flex;
  gap: 5px;
`;

const EventsHistogramContainer = styled.div`
  flex: 3;
`;

const CategoriesHistogramContainer = styled.div`
  flex: 2;
`;

const AlertsWidgets = ({ searchParams, setFilters }: MiddleSectionProps) => (
  <EventsMetrics>
    <WidgetsContainer>
      <EventsHistogramContainer>
        <MetricsAction>
          <ExportResultsButton type="alerts" title="alerts" searchParams={searchParams} />
        </MetricsAction>
        <SecurityEventsHistogram searchParams={searchParams} setFilters={setFilters} />
      </EventsHistogramContainer>
      <IfPermitted permissions={[permissions.securityApp.read]}>
        <CategoriesHistogramContainer>
          <EventsCategoriesHistogram searchParams={searchParams} setFilters={setFilters} />
        </CategoriesHistogramContainer>
      </IfPermitted>
    </WidgetsContainer>
  </EventsMetrics>
);

export default AlertsWidgets;
